import type { ReactNode } from 'react';
import { Avatar, AvatarFallback } from '@savvy-kit/components/avatar';
import numeral from 'numeral';
import { SleeveTagIcon } from 'src/components/net-worth/icons/sleeve-tag';
import { SAVVY_WOB_URL } from 'src/constants/logo-urls/savvy-wob-logo';
import { renderProviderImg } from 'src/utils/image';

export function renderItemIcon(background: string, component: ReactNode) {
  return (
    <Avatar>
      <AvatarFallback style={{ background }}>{component}</AvatarFallback>
    </Avatar>
  );
}

export function renderSleeveIcon() {
  return (
    <>
      {renderProviderImg(SAVVY_WOB_URL, 40)}
      <div className="z-[1] flex -ml-3.5 -mb-1">
        <SleeveTagIcon />
      </div>
    </>
  );
}

export function formatItemValue(value: number | string) {
  return numeral(value).format('$0,0.00');
}

export function portfolioItemSecondaryValueSubtitle(item: { hiddenFromNetWorth?: boolean | null }) {
  if (item.hiddenFromNetWorth) {
    return 'Not in net worth';
  }
  return null;
}
